<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";
  .loading {
    color: colors.get("primary_50");
    position: absolute;
    width: 100%;
    height: 50%;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: utils.in_rem(24px);
    pointer-events: none;

    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 89.84%
    );
    > .message {
      gap: utils.in_rem(16px);
      display: flex;
    }
  }
</style>

<script>
  import Icon from "../../atoms/Icon.svelte";

  let { message = "Loading..." } = $props();
</script>

<div class="loading">
  <div class="message">
    <!-- TODO: fa-spinner-scale -->
    <Icon class="fa-solid fa-spinner fa-spin" size="large" />
    <span>{message}</span>
  </div>
</div>
